import { StyledToggle } from './Toggle.styled';

const Toggle = ({ value = false, onToggle = () => {} }) => {
  return (
    <StyledToggle $isOn={!!value} onClick={onToggle}>
      <div className='toggle-handle-container'>
        <div className='toggle-handle' />
      </div>
    </StyledToggle>
  );
}

export default Toggle;
